import logo from './logo.svg';
import './App.css';
import { NavBar } from './components/Navbar';
import {Banner} from './components/Banner';
import{Projects} from './components/Projects'
import{Contact} from './components/Contact'
import{Footer} from './components/Footer'
import 'bootstrap/dist/css/bootstrap.min.css';


import{Skills} from "./components/Skills";
function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
      
    </div>
  );
}

export default App;


